import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getRoot } from "lexical";
import { useEffect, type FC } from "react";

export const ClickToAppendPlugin: FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerRootListener((rootElement) => {
      if (rootElement !== null) {
        const onClick = (event: MouseEvent): void => {
          console.log({ event, rootElement, target: event.target });
          // If the user clicked the padding/empty space of the root element
          if (event.target === rootElement) {
            editor.update(() => {
              const root = $getRoot();
              const lastChild = root.getLastChild();

              if (
                lastChild === null ||
                lastChild.getTextContentSize() > 0 ||
                lastChild.getType() !== "paragraph"
              ) {
                const p = $createParagraphNode();
                root.append(p);
                p.select();
              } else {
                lastChild.selectEnd();
              }
            });
          }
        };

        rootElement.addEventListener("click", onClick);
        return () => rootElement.removeEventListener("click", onClick);
      }
    });
  }, [editor]);

  return null;
};
